import { EntryPoint, DpPaxRestrictionPropsDefault } from '../models';
import { DateUtils, HotelRoomUtils } from './index';

const {
    maxPassengers,
    maxKidsPerAdult,
    maxKidsAge,
    maxInfantAge,
    recommendedAdultsPerRoom,
    maxRoomsWithAdults
} = DpPaxRestrictionPropsDefault;

export const DynpackRoomUtils = {
    isNonPrimeHotelRoomKidsAgeInvalid(room) {
        return room.kids.includes(-1);
    },

    getNonPrimeAgeKidsValidation(nonPrimeHotelRoom) {
        return nonPrimeHotelRoom.kids.some((kidAge) => kidAge === -1);
    },

    getRoomSelection(pax, rooms, product = EntryPoint.DP) {
        if (HotelRoomUtils.hasEmptyRoom(rooms) || product !== EntryPoint.DP) {
            return pax.adults === maxPassengers
                ? this.getRoomSelectionFromPaxSelectionWithMaxPaxLimitation(maxRoomsWithAdults)
                : this.getRoomSelectionFromPaxSelection(pax);
        }
        return rooms;
    },

    getRoomSelectionFromPaxSelectionWithMaxPaxLimitation(maxRoomsWithAdults) {
        return Array.from(Array(maxRoomsWithAdults)).map(() => HotelRoomUtils.getModelRoom(maxRoomsWithAdults));
    },

    getRoomSelectionFromPaxSelection(pax) {
        let { adults, kids, infants } = pax;
        let automaticRooms = [];
        const roomsNeeded = Math.max(
            Math.ceil(adults / recommendedAdultsPerRoom),
            Math.ceil((kids + infants) / maxKidsPerAdult),
        );
        let adultsExtras = adults - roomsNeeded;
        for (let i = 0; i < roomsNeeded; i++) {
            let adultsRoom = 1;
            if (adultsExtras > 0) {
                adultsRoom++;
                adultsExtras--;
            }
            let {
                kidsRoom,
                infantsRoom,
            } = this.getAutomaticInfantsRoomSelection(kids, infants);
            kids = kids - kidsRoom.length;
            infants = infants - infantsRoom.length;

            automaticRooms.push(HotelRoomUtils.getModelRoom(adultsRoom, infantsRoom.concat(kidsRoom)));
        }
        return automaticRooms;
    },

    getAutomaticInfantsRoomSelection(kids, infants) {
        let kidsRoom = [];
        let infantsRoom = [];
        let guest = 0;
        for (let j = 0; guest < maxKidsPerAdult && kids + infants > 0; j++) {
            if (kids > 0) {
                kidsRoom.push(maxKidsAge);
                kids--;
                guest++;
            }
            if (infants > 0 && guest < maxKidsPerAdult) {
                infantsRoom.push(maxInfantAge);
                infants--;
                guest++;
            }
        }
        return { kidsRoom, infantsRoom };
    },

    getSeparateStayValidDate(separateStayDate, segmentDate, factor) {
        const isValid =
            DateUtils.isValidDate(separateStayDate) &&
            DateUtils.compare(separateStayDate, segmentDate) === factor;
        return isValid ? separateStayDate : segmentDate;
    },
};
